import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutOfficePendingPayAdjustmentList extends Layout {
    layoutheaderPendingPayAdjustments: LayoutHeader;
    sourceOffPendingDeduct: DataSource;
    tablePayAdjustments: Table;
}
